import { z } from 'zod'

// Own file so API contracts can import it: the web build only lets *.schema.ts / *.contract.ts
// cross the package boundary, and this one may import `zod` only.
export const splitPlanSchema = z.object({
  documentType: z.enum(['lab', 'document']),
  labName: z.string().trim().min(1).optional(),
  referringProviderId: z.string().optional(),
  notifyPatient: z.boolean(),
  groups: z
    .array(
      z.object({
        pages: z.array(z.number().int().positive()).min(1),
        patientId: z.string().min(1),
        title: z.string().trim().min(1),
      }),
    )
    .min(1),
})

export type SplitPlan = z.infer<typeof splitPlanSchema>
